<button #alertTrigger (onMenuOpen)="onMenuOpen()" [disabled]="!hasAlerts" [matMenuTriggerFor]="toolbarAlertMenu"
  [ngClass]="alertTriggerBtn && alertTriggerBtn.menuOpen || !hasAlerts?'':'pulse'" color="warn" mat-icon-button>
  <mat-icon fontIcon="fa-bell" fontSet="fas" style="font-size:22px;"></mat-icon>
  @if (alertCount>0 && alertCount < 10) {
    <span
    style="color: white; position: absolute; left: 20px; font-size: 14px; padding-top: 2px;">{{ alertCount }}</span>
  }
  @if (alertCount>=10 ) {
    <span style="color: white; position: absolute; left: 16px; font-size: 14px; padding-top: 2px;">{{ alertCount
    }}</span>
  }
</button>

<mat-menu #toolbarAlertMenu="matMenu" class="padded-menu" xPosition="before">
  @if (!alertData) {
    <p>Loading...</p>
  }
  @if (alertData) {
    @for (problemDay of alertData.dates; track problemDay) {
      <div>
        <div class="date-separator">
          {{
          problemDay.date | amCalendar:{
          sameDay: '[Today]',
          nextDay: '[Tomorrow]',
          nextWeek: 'dddd',
          lastDay: '[Yesterday]',
          lastWeek: '[Last] dddd',
          sameElse: 'DD/MM/YYYY'
        }
        }}
        <span class="spacer"></span> {{ problemDay.totalAlerts }} Issue{{ problemDay.totalAlerts > 1 ? 's' : '' }}
      </div>
      @if (problemDay.tickets) {
        @for (ticket of problemDay.tickets; track ticket) {
          <div (click)="openTicketDialog(ticket.ticket)" class="alert-menu-widget">
            @if (ticket.ticketId) {
              <div>
                @if (ticket.ticket.visit.job) {
                  Ticket {{ ticket.ticket.id }} for job {{ ticket.ticket.visit.job.externalJobReference }}<br />
                } @else {
                  Meeting Ticket {{ ticket.ticket.id }} for {{ ticket.ticket.visit.visitType?.description }} - {{ ticket.ticket.visit.meeting.description }}<br />
                }
                Currently assigned to {{ ticket.ticket.resourceAvailability.resource.name }}
                at {{ ticket.ticket.startedTime | amDateFormat : 'HH:mm' }}
                <ul>
                  @for (issue of ticket.issues; track issue) {
                    <li>{{ issue }}</li>
                  }
                </ul>
              </div>
            }
            @if (!ticket.ticketId) {
              <div>
                Loading..
              </div>
            }
          </div>
        }
      }
      @if (problemDay.resourceAvailabilities) {
        @for (resourceAvailability of problemDay.resourceAvailabilities; track resourceAvailability) {
          <div (click)="openResourceAvailabilityDialog(resourceAvailability.availabilityId)" class="alert-menu-widget">
            @if (resourceAvailability.availability) {
              <div>
                {{ resourceAvailability.availability.resource.name }}<br />Shift starting at
                {{ resourceAvailability.availability.start | amDateFormat : 'DD/MM/YYYY HH:mm' }}
                <br />
                Normal/High/Emergency Reservations:
                @if (resourceAvailability.availability.normalPriorityReservationPercent) {
                  <span>
                    {{ resourceAvailability.availability.normalPriorityReservationPercent }}%
                  </span>
                }
                @if (resourceAvailability.availability.normalPriorityReservationDuration) {
                  <span>
                    {{ resourceAvailability.availability.normalPriorityReservationDuration / 60 }} mins
                  </span>
                }
                @if (!resourceAvailability.availability.normalPriorityReservationPercent && !resourceAvailability.availability.normalPriorityReservationDuration) {
                  <span
                  >Off</span>
                }
                /
                @if (resourceAvailability.availability.highPriorityReservationPercent) {
                  <span>
                    {{ resourceAvailability.availability.highPriorityReservationPercent }}%
                  </span>
                }
                @if (resourceAvailability.availability.highPriorityReservationDuration) {
                  <span>
                    {{ resourceAvailability.availability.highPriorityReservationDuration / 60 }} mins
                  </span>
                }
                @if (!resourceAvailability.availability.highPriorityReservationPercent && !resourceAvailability.availability.highPriorityReservationDuration) {
                  <span
                  >Off</span>
                }
                /
                @if (resourceAvailability.availability.emergencyPriorityReservationPercent) {
                  <span>
                    {{ resourceAvailability.availability.emergencyPriorityReservationPercent }}%
                  </span>
                }
                @if (resourceAvailability.availability.emergencyPriorityReservationDuration) {
                  <span>
                    {{ resourceAvailability.availability.emergencyPriorityReservationDuration / 60 }} mins
                  </span>
                }
                @if (!resourceAvailability.availability.emergencyPriorityReservationPercent && !resourceAvailability.availability.emergencyPriorityReservationDuration) {
                  <span
                  >Off</span>
                }
                <ul>
                  @for (issue of resourceAvailability.issues; track issue) {
                    <li>{{ issue }}</li>
                  }
                </ul>
              </div>
            }
            @if (!resourceAvailability.availability) {
              <div>
                Loading..
              </div>
            }
          </div>
        }
      }
    </div>
  }
}

</mat-menu>
